import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { logout as logoutRequest } from "../lib/api/auth";
import { useAuth } from "../providers/AuthProvider";
import { queryClient } from "../lib/queryClient";

/** Shared sign-out flow: clears the server cookie, local auth state, and cache,
 * then routes to /login. Logout is idempotent, so it clears locally regardless. */
export function useLogout(): () => Promise<void> {
  const navigate = useNavigate();
  const { signOutLocal } = useAuth();

  return useCallback(async () => {
    try {
      await logoutRequest();
    } catch {
      // idempotent — clear locally even if the request fails.
    }
    signOutLocal();
    queryClient.clear();
    navigate("/login", { replace: true });
  }, [navigate, signOutLocal]);
}
